import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ConversationAssistantNavBarControllers: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConversationAssistantNavBarControllers" */ '../src/navBarControllers.tsx'
			)
		).ConversationAssistantNavBarControllers,
});
